import { render, staticRenderFns } from "./updatamechanicalarm.vue?vue&type=template&id=0bbb5eb6&"
import script from "./updatamechanicalarm.vue?vue&type=script&lang=js&"
export * from "./updatamechanicalarm.vue?vue&type=script&lang=js&"
import style0 from "./updatamechanicalarm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports